import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/layouts/default.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/layouts/landing.vue").then(m => m.default || m))
}